import React from 'react';
import { Button } from 'primereact/button';

export default function ThemeToggle({ theme, onToggle }) {
    return (
        <Button
            icon={theme === 'light' ? 'pi pi-moon' : 'pi pi-sun'}
            onClick={onToggle}
            className="p-button-rounded p-button-text"
            tooltip={theme === 'light' ? 'Cambiar a tema oscuro' : 'Cambiar a tema claro'}
            tooltipOptions={{ position: 'bottom' }}
            aria-label={`Cambiar a tema ${theme === 'light' ? 'oscuro' : 'claro'}`}
            size='large'
        />
    );
}
